import { ContextStore } from "../../../react-core/Flux/Variables";
import { CurrencySymbolDictionary } from "../../../react-core/Html/Resources/CurrencySymbolDictionary";
import { CurrencyCode } from "../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../Wrap/Core/DataTypes/Money";

export class MoneyHelper {
    static getDefaultCurrency(): CurrencyCode {
        return CurrencyCode.GBP;
    }

    static getMoneyString(money: Money): string {
        if (money == null || money.Amount == null) {
            return null;
        }
        const amount = Globalize.format(money.Amount, "N0", ContextStore.getContext().culture)
        const currency = CurrencySymbolDictionary.getSymbol(money.Currency);

        return currency + amount;
    }

    static getMoneyWithProperFormat(money: Money): Money {

        if (money == null || money.Amount == null) {
            return this.getDefaultMoney();
        }
        else {
            return money;
        }
    }

    static getDefaultMoney(): Money {
        return {
            Amount: 0,
            Currency: this.getDefaultCurrency()
        };
    }

    static add(moneyA: Money, moneyB: Money): Money {
        if (!moneyA || !moneyB || moneyA.Currency != moneyB.Currency) {
            throw new Error("Add money error.")
        }
        return {
            Amount: moneyA.Amount + moneyB.Amount,
            Currency: moneyA.Currency
        } as Money;
    }

    static multiplyBy(multiplier: number, moneyMultiplicand: number): Money {
        return {
            Amount: multiplier * moneyMultiplicand,
            Currency: this.getDefaultCurrency()
        } as Money;
    }

    public static roundNumberToDecimalPlaces(number: number, decimalPlaces: number): number {
        return Math.round(Math.pow(10, decimalPlaces) * number) / Math.pow(10, decimalPlaces);
    }
}